import styled from "styled-components";

export const Spinner = styled.div`
  border: 2px solid #ffffff;
  border-radius: 50%;
  border-top: 2px solid black;
  width: 30px;
  height: 30px;
  animation: spin 1.5s linear infinite;
  margin: 0px auto;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
